import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { useCurrentUrl } from '../../../utils/routing';
import { getScrollBarStyles } from '../../../config/styles';
import ResponsiveChartWrapper from '../ResponsiveChartWrapper';
import { ChartMode } from '../types';
import { useFullscreenContext } from '../../../utils/contexts/FullscreenContext';
import { theme } from '../../../styles/theme';

interface IProps {
  analysisId: string;
  children: ReactNode;
  mode: ChartMode;
}

const OverflowingWrapper = styled.div`
  flex: 1;
  border: 1px solid ${theme.colors.border};
  overflow-x: auto;
  ${getScrollBarStyles(4)};
`;

const SankeyChartWrapper = ({ analysisId, children, mode }: IProps) => {
  const { isFullScreen } = useFullscreenContext();
  const { isReportInUrl } = useCurrentUrl();
  const notResponsive =
    isFullScreen || (isReportInUrl && mode !== ChartMode.Compact);

  // disabling default browser context menu
  // in order to make our custom context menus (expand, create cohort, etc.)
  // be a single UI element
  const handleContextMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  if (notResponsive) {
    return (
      <OverflowingWrapper onContextMenu={handleContextMenu}>
        {children}
      </OverflowingWrapper>
    );
  }

  return (
    <ResponsiveChartWrapper analysisId={analysisId} mode={mode}>
      {children}
    </ResponsiveChartWrapper>
  );
};

export default SankeyChartWrapper;
